import { Dimmer } from 'semantic-ui-react';
import { DebouncedLoader } from './DebouncedLoader';

type Props = {
  isFetching?: boolean;
  inline?: boolean | 'centered';
  margin?: string;
};

export const LockingLoader = (props: Props) => {
  return (
    <Dimmer active={props.isFetching ?? true}>
      <DebouncedLoader {...props} />
    </Dimmer>
  );
};
